import "core-js/modules/es.array.join";

/*
 Copyright (c) 2017 Wells Fargo. 455 Market St., San Francisco, CA 94105 All rights reserved.

 This software is the confidential and proprietary information of Wells Fargo
 bank. ('Confidential Information'). You shall not disclose such Confidential
 Information and shall use it only in accordance with the terms of the license
 agreement you entered into with WellsFargo.

 Author: Thomas Barry
*/
var charSet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
var charSetSize = charSet.length;
var uniqueId = 0;

var unique = function unique() {
  var length = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 8;
  var id = [];
  var randPos;

  for (var i = 1; i <= length; i++) {
    // eslint-disable-next-line wf-security/no-math-random
    randPos = Math.floor(Math.random() * charSetSize);
    id.push(charSet[randPos]);
  }

  return id.join('');
};

var nonUnique = function nonUnique() {
  uniqueId += 1;
  var s = '000000' + uniqueId;
  return 'A' + s.substr(s.length - 7);
};

export var resetUnique = function resetUnique() {
  uniqueId = 0;
};
export default (function (length) {
  return (window.mwfGlobals || {})._unitTests ? nonUnique() : unique(length);
});